"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_final_form_1 = require("react-final-form");

var FormControl_1 = require("../../components/FormControl");

var util_1 = require("./util");

function Field(props) {
  var form = react_final_form_1.useForm();
  react_1.useEffect(function () {
    if (props.convert) {
      var setFieldData = form.mutators.setFieldData;

      if (setFieldData) {
        setFieldData(getFieldName(), {
          convert: props.convert
        });
      } else {
        throw new Error('Form must have a setFieldData mutator so Field can define a convert function');
      }
    }
  }, []);

  var getFieldName = function getFieldName() {
    if (typeof props.name === 'string') {
      return props.name;
    } else {
      return props.name.absolutePath();
    }
  };

  var renderComponent = function renderComponent(fieldProps) {
    var customOnChange = function customOnChange(value) {
      // External onChange prop is killed by final-form, so we merge the external and the internal one
      fieldProps.input.onChange(value);
      fieldProps.custom.onChange && fieldProps.custom.onChange(value);
    };

    var renderProps = __assign({}, fieldProps, {
      input: __assign({
        'aria-label': props.label
      }, fieldProps.input, {
        onChange: customOnChange
      }),
      hasError: !!util_1.getFieldError(fieldProps)
    });

    if (props.hasWrapper) {
      return react_1.default.createElement(FormControl_1.FormControl, {
        id: props.id,
        name: getFieldName(),
        error: util_1.getFieldError(fieldProps),
        label: props.label,
        required: props.required
      }, props.render(renderProps));
    }

    return props.render(renderProps);
  };

  var onChange = props.onChange,
      name = props.name,
      rest = __rest(props, ["onChange", "name"]);

  return react_1.default.createElement(react_final_form_1.Field, __assign({}, rest, {
    name: getFieldName(),
    custom: {
      onChange: onChange
    },
    render: renderComponent
  }));
}

exports.Field = Field;
Field.defaultProps = {
  hasWrapper: true
};